<template>
  <a
    class="jiffy-promotion-blanks js-jiffy-promotion"
    href="/?seller=JiffyShirts"
    :target="openInSameTab ? '_self' : '_blank'"
    data-mixpanel-listen="click"
    data-mixpanel-event="crosssell_cta_blanks_free_shipping_offer_click"
    :data-mixpanel-data="
      JSON.stringify({
        page: 'cart',
        business_line_promo_type: 'Blanks',
        promotion_name: `spend_${spendThreshold}_get_free_shipping`
      })
    "
  >
    <div class="jiffy-promotion-blanks__free-shipping-wrapper">
      <UseSvg class="jiffy-promotion-blanks__free-shipping-icon" icon="free-shipping-truck" />
      <span>FREE SHIPPING</span>
    </div>
    <div class="jiffy-promotion-blanks__info-wrapper">
      <div class="jiffy-promotion-blanks__info">
        <UseSvg class="jiffy-promotion-blanks__logo-icon" icon="jiffy-shirts-inline" />
        <p class="jiffy-promotion-blanks__info-text">
          Spend {{ n(spendThreshold, "currencyNoCents") }}+ on DTF,
          <strong>get free shipping for blank apparel</strong> shipped from Jiffy!
        </p>
      </div>
    </div>
  </a>
</template>

<script>
import { n } from "components/jiffy/vue-cart/helpers/currency";
import UseSvg from "components/jiffy/vue-cart/UseSvg.vue";

export default {
  name: "JiffyPromotionBlanks",
  components: { UseSvg },
  props: {
    spendThreshold: {
      type: Number,
      required: true
    },
    openInNewTab: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isMobileApp() {
      return Boolean(window.MOBILE_APP);
    },
    openInSameTab() {
      return this.isMobileApp || !this.openInNewTab;
    }
  },
  setup() {
    return { n };
  }
};
</script>

<style lang="scss" scoped>
@import "frontend/init/jiffy/settings.scss";

.jiffy-promotion-blanks {
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  gap: 16px;
  background-color: $gray-foggy;
  min-height: 90px;
  padding: 8px;
  border-radius: 6px;
  min-width: 380px;
  color: $text-black;
  text-decoration: none;

  &__free-shipping-wrapper {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    padding: 8px 0;
    flex-basis: 100px;
    height: auto;
    gap: 2px;
    border: $crafterpay-primary-700 2px solid;
    border-radius: 6px;
    font-size: 17px;
    font-weight: 800;
    line-height: 15px;
    background: linear-gradient(180deg, $white 0%, $white-darker 100%);
  }

  &__free-shipping-icon {
    width: 53px;
    height: 42px;
  }

  &__info-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 23px;
    flex: 1;
  }

  &__info {
    font-size: 16px;
    font-weight: 400;
    line-height: 21px;
  }

  &__info-text {
    margin: 0;
    padding: 0;
  }

  &__logo-icon {
    width: 130px;
    height: 19px;
    margin-bottom: 8px;
  }
}
</style>
